<template>
  <v-navigation-drawer :value="isOpen" absolute floating @input="onClose">
    <v-stepper vertical non-linear>
      <template v-for="(item, idx) in items">
        <v-stepper-step
          :key="`${idx + 1}-step`"
          :complete="item.state != null"
          :step="idx + 1"
          :complete-icon="`fas fa-check`"
          :error-icon="`fas fa-exclamation`"
          @click="onSelect(item)"
          v-bind:class="{ current: item.current }"
        >
          <template v-if="itemsQuestion[idx] != null">
            {{ itemsQuestion[idx].question | pureText }}
          </template>
        </v-stepper-step>
      </template>
    </v-stepper>
  </v-navigation-drawer>

  <!-- <v-dialog
    v-model="isOpen"
    max-width="400"
    fullscreen
    hide-overlay
    transition="slide-x-transition"
    scrollable
  >
    <v-card>
      <v-btn icon large @click="onDismiss()">
        <v-icon small>far fa-arrow-left</v-icon>
      </v-btn>
      <v-row class="pa-4 pt-12 ma-0">
        <v-col cols="12" sm="12" md="8" lg="6">
          <h2 class="text-center mb-4">เลือกคำถาม</h2>
          <v-list>
            <v-list-item-group v-model="selected" active-class="primary--text">
              <template v-for="(item, idx) in items">
                <v-list-item
                  :key="`qselector_${item.priority}`"
                  @click="onSelect(item)"
                >
                  <v-list-item-avatar size="32">
                    <div class="prefix-number">{{ idx + 1 }}</div>
                  </v-list-item-avatar>
                  <v-list-item-title>
                    <div v-if="!everClickDone && isAlertThemNotDone(item)">
                      ยังไม่ได้ทำ
                    </div>
                    {{ itemsQuestion[idx].question | pureText }}
                  </v-list-item-title>
                  <v-list-item-action v-if="item.state != null">
                    <v-icon color="green">far fa-check-circle</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog> -->
</template>

<script>
export default {
  props: ["isOpen", "questions", "questionsList"],
  computed: {
    items() {
      if (this.questions != null) {
        return this.questions;
      }
      return [];
    },
    itemsQuestion() {
      return this.questionsList.filter((x) => x.typeQuestion != "article");
    },
    everClickDone() {
      return this.$store.getters.isEverClickDone;
    },
  },
  methods: {
    onSelect(item) {
      this.$emit("onSelect", item);
      this.onClose(false);
    },
    addDotExceed(string, limit) {
      var dots = "...";
      let pureText = string.replace(/<[^>]*>/g, "");
      if (pureText.length > limit) {
        // you can also use substr instead of substring
        pureText = pureText.substring(0, limit) + dots;
      }
      return pureText;
    },
    isAlertThemNotDone(item) {
      return item.state === null;
    },
    onClose(val) {
      if (val === false) {
        this.$emit("update:isOpen", false);
      }
    },
  },
  watch: {
    // isOpen(flag) {
    //   if (flag == false) {
    //     this.$emit("update:isOpen", flag);
    //   }
    // },
  },
};
</script>
<style lang="scss">
$text: #345;
$subtext: #737e8a;
$border: #efefef;
$warning: #ff9800;
$success: #4caf50;
$background: #f5f5f5;
$white: #ffffff;
$current: #1976d2;

.v-navigation-drawer {
  background: $background !important;
  z-index: 3 !important;
  box-shadow: none !important;
  height: 100%;
}

.v-stepper--vertical {
  box-shadow: none !important;
  padding: 12px;
  position: relative;
  background: transparent !important;

  .v-stepper__step {
    padding: 12px 8px !important;
    cursor: pointer;
    border-radius: 8px;
    transition: 0.2s !important;

    .v-stepper__step__step {
      z-index: 1;
      width: 20px;
      height: 20px;
      min-width: initial;
      flex-shrink: 0;
      font-size: 0.625rem;

      i {
        font-size: 0.5625rem !important;
        color: $white !important;
      }
    }

    .v-stepper__label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      color: $text !important;
      font-weight: normal;

      small {
        display: block;
        color: $subtext;
        font-size: 11px;
        margin-top: 4px;
      }
    }

    &.current {
      background: rgba($current, 0.12) !important;

      .v-stepper__label {
        color: $current !important;
      }
    }

    &.current {
      .v-stepper__step__step {
        background: $current !important;
      }
    }

    &.v-stepper__step--error {
      .v-stepper__step__step {
        background: $warning !important;
      }
    }

    &.v-stepper__step--complete {
      .v-stepper__step__step {
        background: $success !important;
      }
    }

    &:hover {
      background: rgba(0.25, 0.8, 0.5, 0.04);
    }

    &:not(:first-child)::before {
      content: "";
      width: 1px;
      height: 100%;
      position: absolute;
      bottom: 50%;
      left: 18px;
      background: #e0e0e0;
    }

    &:not(.v-stepper__step--error):not(.v-stepper__step--complete):not(.current) {
      .v-stepper__step__step {
        background: rgb(224 224 224) !important;
        color: #345;
      }
    }
  }
}
</style>